import React from 'react';

import {
  RunsDataQueryConfig,
  toRunsDataQueryConfig,
} from '../../containers/RunsDataLoader';
import type {PanelSpec} from '../../util/panelTypes';
import {Query} from '../../util/queryTypes';
import {MarkdownConfig} from './common';
export type {MarkdownConfig};

const PANEL_TYPE = 'Markdown Panel';

const transformQuery = (query: Query): RunsDataQueryConfig => {
  const result = toRunsDataQueryConfig(query, undefined, {
    panelType: PANEL_TYPE,
  });
  result.disabled = true;
  return result;
};

export const Spec: PanelSpec<typeof PANEL_TYPE, MarkdownConfig> = {
  type: PANEL_TYPE,
  Component: React.lazy(() => import('./Component')),
  transformQuery,
  noEditMode: true,
  icon: 'panel-text',
};
